import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";
import logoImage from "../assets/COT_logo-removebg-preview.png";
import IataImage from "../assets/pngwing.com.png";
import { useRecoilState } from "recoil";
import airportList from "../directories/AirportCode";
import Company from "../directories/Company";
import AirlineCode from "../directories/AirlineCode";
import { agentState } from "../App.js"
import { db } from "../firebaseConfig.js";
import {
  collection,
  getDocs,
} from "firebase/firestore";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 40,
  },
  section: {
    marginTop: 5,
  },
  text: {
    fontSize: 12,
  },
  text2: {
    fontSize: 12,
    textAlign: "center",
  },
  footerText: {
    // backgroundColor:"pink",
    width: "100%",
  },
  textBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  upper: {
    width: "100%",
    height: "10%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    // backgroundColor:"red"
  },
  watermark: {
    position: "fixed",
    // top: "50%",
    // left: "50%",
    // transform: "translate(-50%, -50%)",
    // top:2000,
    fontSize: 50,
    color: "rgba(0,0,0,0.1)", // Light gray with transparency
    fontWeight: "bold",
    zIndex: -1,
    opacity: 0.3,
  },
  Watermarlogo: {
    width: 550,
    height: 730,
    objectFit: "contain",
    position: "absolute",
    top: 400,
    left: 160,
  },
  logo: {
    width: 200,
    height: 180,
    objectFit: "contain",
  },
  IataLogo: {
    width: "auto",
    height: 35,
    objectFit: "fit",
  },
  titleHolder: {
    width: "100%",
    textAlign: "center",
  },
  folderInfoSection: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
  },
  folderInfo: {
    width: "40%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  agentInfo: {
    width: "35%",
    height: "100%",
  },

  RefInfo: {
    width: "45%",
  },
  destinInfo: {
    width: "55%",
  },
  refRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
    marginTop: 3,
  },

  destRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 3,
  },
  divider: {
    height: "1px",
    backgroundColor: "black",
    width: "100%",
    marginTop: "3%",
    marginBottom: "2%",
    opacity: "0.3",
  },
  divider2: {
    height: "1px",
    backgroundColor: "black",
    width: "100%",
    marginTop: "2%",
    marginBottom: "2%",
    opacity: "0.3",
  },
  OverAllInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  amountTitle: {
    width: "30%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    // justifyContent: "space-between",
    // backgroundColor:"black"
  },
  amountTitle2: {
    width: "30%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    justifyContent: "space-between",
    // backgroundColor:"black"
  },
  detailInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 2,
  },
  passengerdetails: {
    display: "flex",
    flexDirection: "row",

    width: "70%",
  },
  detailInfoView: {
    width: "100%",
  },
  passengername: {
    marginLeft: 30,
  },

  allpurchaseList: {
    marginTop: 10,
  },

  infodetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 2,
  },

  footer: {
    position: "absolute",
    bottom: 20,
    display: "flex",
    flexDirection: "colume",
    justifyContent: "space-between",
    width: "100%",
    justifyContent: "center",
    // backgroundColor:"pink",
    // right:10
    // paddingRight:20
  },
  footerInner: {
    // position: "absolute",
    // bottom: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "90%",
  },
  banner: {
    marginTop: 10,
    textAlign: "center",
    backgroundColor: "grey",
    padding: 7,
    fontSize: 11,
    fontWeight: "100",
    borderRadius: 2,
  },
  heading: {
    marginLeft: 150,
    marginTop: 20,
    marginBottom: 20,
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
  },
  flightSegment: {
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-between",
    marginBottom: 20,
  },
  flightDetails: {
    marginLeft: 85,
  },
  termConditions: {
    marginTop: 20,
    marginBottom: 20,
  },
});

const getAirlineName = (flightNo) => {
  const airlineCode = flightNo.slice(0, 2);

  const airline = AirlineCode.find((item) => item.code === airlineCode);

  return airline ? airline.name : "Airline not found";
};


 
const MyDocument = ({
  users,
  travels,
  hotels,
  transport,
  visa,
  ourReference,
  agentsName,
  totalQuote,
  totalPaid,
  bank,
  agents
}) => {
  const travelListWithType = travels.map((item) => ({
    ...item,
    type: "Travel",
  }));
  const hotelListWithType = hotels.map((item) => ({
    ...item,
    type: "Hotel",
    date: item.date,
  }));
  const transportListWithType = transport.map((item) => ({
    ...item,
    type: "Transport",
  }));

  const convertToTime = (timeStr) => {
    const hours = parseInt(timeStr.substring(0, 2), 10);
    const minutes = parseInt(timeStr.substring(2, 4), 10);

    const now = new Date();
    now.setHours(hours, minutes, 0, 0);

    return now;
  };

  const customSort = (a, b) => {
    const dateComparison = new Date(a.date) - new Date(b.date);
    if (dateComparison !== 0) return dateComparison;

    const timeComparison =
      convertToTime(a.departure) - convertToTime(b.departure);
    if (timeComparison !== 0) return timeComparison;
  };

  // Sort the travels array and save it
  const sortedTravels = [...travelListWithType].sort(customSort);

  // Step 2: Merge all lists into one
  const combinedList = [
    ...sortedTravels,
    ...hotelListWithType,
    ...transportListWithType,
  ];

  // Step 3: Sort the merged list by date
  const sortedCombinedList = combinedList.sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const [totalQoute, settotalQoute] = useState(totalQuote);

  const [CurrencyType, setCurrencyType] = useState("GBP");

  const [FolderNumber, setFolderNumber] = useState(ourReference);



  return (
    <Document>
      <Page size="TABLOID" style={styles.page} wrap>
        {/* <Text style={styles.watermark}>CONFIDENTIAL</Text>
      
      */}
        <View style={styles.watermark}>
          <Image src={logoImage} style={styles.Watermarlogo} />
        </View>

        <View style={styles.upper}>
          <View style={styles.section}>
            <Text style={styles.text}>{Company[0].name}</Text>
            <Text style={styles.text}>

{bank === "American" ? (
                <Text> 104 Province Dr, Apt D, Richmond, VA<br/></Text>
              ) : (
                <>{Company[0].address}</>
              )}

            </Text>
            <Text style={styles.text}>

              {bank === "American" ? (
                <Text>23229, US</Text>
              ) : (
                <>{Company[0].address2}</>
              )}

            </Text>
            <Text style={styles.text}>

              {bank === "American" ? (
                <Text>www.crossoceantravel.com</Text>
              ) : (
                <>{Company[0].website}</>
              )}
            </Text>

            
               

          </View>
          <View style={styles.section}>
            <Image src={logoImage} style={styles.logo} />
          </View>
        </View>

        <View style={styles.titleHolder}>
          <Text style={styles.textBold}>INVOICE</Text>
        </View>

        <View style={styles.folderInfoSection}>
          <View style={styles.folderInfo}>
            <View style={styles.RefInfo}>
              <View style={styles.refRow}>
                <Text style={styles.text}>Our Ref:</Text>

                <Text style={styles.text}>{FolderNumber}</Text>
              </View>

              <View style={styles.refRow}>
                <Text style={styles.text}>Your Ref:</Text>

                <Text style={styles.text}></Text>
              </View>
              <View style={styles.refRow}>
                <Text style={styles.text}>Order No:</Text>

                <Text style={styles.text}>{FolderNumber}</Text>
              </View>
            </View>

            <View style={styles.destinInfo}>
              <View style={styles.destRow}>
                <Text style={styles.text}>Destination:</Text>

                <Text style={styles.text}>
                  {Array.isArray(travels) && travels[0] && travels[0].to != null
                    ? travels[0].to
                    : ""}
                </Text>
              </View>

              <View style={styles.destRow}>
                <Text style={styles.text}>Departure Date:</Text>

                {/* <Text style={styles.text}>
  {Array.isArray(travels) && travels[0] && travels[0].to != null ? (
    "No date available"
  ) : (
    // Render formatted date when the date is not empty
    new Date(travels[0].date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  )}
</Text> */}

                {travels[0] && (
                  <Text style={styles.text}>
                    {new Date(travels[0].date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </Text>
                )}
              </View>
              <View style={styles.destRow}>
                <Text style={styles.text}>Cust ID:</Text>

                <Text style={styles.text}>{FolderNumber}</Text>
              </View>
            </View>
          </View>

          <View style={styles.agentInfo}>
            <View style={styles.agentInner}>
              <View style={styles.destRow}>
                <Text style={styles.text}>Agent:</Text>

                <Text style={styles.text}>{agentsName}</Text>
              </View>

              <View style={styles.destRow}>
                <Text style={styles.text}>Agent Phone:</Text>

                <Text style={styles.text}>
                  {agents.find((agent) => agent.id === agentsName)?.Phone}
                </Text>
              </View>
              <View style={styles.destRow}>
                <Text style={styles.text}>Agent Email:</Text>

                <Text style={styles.text}>
                  {" "}
                  {agents.find((agent) => agent.id === agentsName)?.Email}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.divider}></View>

        <View style={styles.OverAllInfo}>
          <View style={styles.descriptionTitle}>
            <Text style={styles.text}>Description</Text>
          </View>

          <View style={styles.amountTitle}>
            <Text 
            style={[styles.text, {width:"50%",textAlign:"right"}]}
            >Amount</Text>

            <Text 
              style={[styles.text, {width:"50%",textAlign:"right"}]}
            >Total</Text>
          </View>
        </View>

        <View style={styles.detailInfo}>
          <View style={styles.detailInfoView}>
            {travels.length > 0 ? (
              <View style={styles.passengerdetails}>
                <Text style={styles.text}>Flight :</Text>

                <View style={styles.passengername}>
                  <Text style={styles.text}>Passengers :</Text>

                  <Text style={styles.text}>
                    {users[0].title +
                      " " +
                      users[0].firstName +
                      " " +
                      users[0].middleName +
                      " " +
                      users[0].lastName}
                  </Text>

                  {travels[0] && (
                    <Text style={styles.text}>
                      {airportList.find(
                        (airport) => airport.code === travels[0].to
                      )?.name || "Unknown Airport"}{" "}
                      ({travels[0].to})
                    </Text>
                  )}
                </View>
              </View>
            ) : (
              <View style={styles.passengername}>
                {/* <Text style={styles.text}>Passengers :</Text> */}

                <Text style={styles.text}>
                  {users[0].title +
                    " " +
                    users[0].firstName +
                    " " +
                    users[0].middleName +
                    " " +
                    users[0].lastName}
                </Text>
              </View>
            )}
          </View>

          <View style={styles.amountTitle2}>
            <Text style={styles.text}>
              {(Number(totalQoute) || 0).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>

            <Text style={styles.text}>
              {(Number(totalQoute) || 0).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </View>
        </View>

        <View style={styles.allpurchaseList}>
          {hotels.map((hotel, index) => (
            <Text key={index} style={styles.text}>
              {hotel.name +
                "  - " +
                0 +
                hotel.numberOfRooms +
                " " +
                hotel.roomType +
                " with " +
                hotel.boardType}
            </Text>
          ))}

          {visa.map((visa, index) => (
            <Text key={index} style={styles.text}>
              {visa.numberOfVisa + " " + visa.visaType}
            </Text>
          ))}

          {transport.map((transport, index) => (
            <Text key={index} style={styles.text}>
              {transport.carType +
                " " +
                transport.pickupLocation +
                " to " +
                transport.dropoffLocation}
            </Text>
          ))}
        </View>

        <View style={styles.divider2}></View>

        <View style={styles.paymentInfo}>
          <View style={styles.infodetails}>
            <Text style={styles.text}>Total for Service :</Text>

            <Text style={styles.text}>
              {(Number(totalQoute) || 0).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </View>

          <View style={styles.infodetails}>
            <Text style={styles.text}>Already Paid :</Text>

            <Text style={styles.text}>
              {(Number(totalPaid) || 0).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </View>

          <View style={styles.infodetails}>
            <Text style={styles.text}>Remaining Balance :</Text>

            <Text style={styles.text}>
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "2-digit",
              })}
            </Text>

            <Text style={styles.text}>
  {bank === "Allied" ? (
    <Text>PKR</Text>
  ) : bank === "American" ? (
    <Text>USD</Text>
  ) : (
    <Text>{CurrencyType}</Text>
  )}
</Text>

            <Text style={styles.text}>
              {(Number(totalQoute - totalPaid) || 0).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </View>
        </View>

        <View style={styles.divider2}></View>
        <View style={styles.divider2}></View>

        <View style={styles.footer}>
          {/* <View style={styles.divider2}></View> */}

          <View style={styles.footerInner}>
            <Image src={IataImage} style={styles.IataLogo} />

            <View style={styles.footerText}>
              <Text style={styles.text2}>
                 {bank === "American" ? (
                <Text>www.crossoceantravel.com</Text>
              ) : (
                <>{Company[0].website}</>
              )}
              </Text>
              <Text style={styles.text2}>
                {bank === "American" ? (
                <Text>complaint@crossoceantravel.com</Text>
              ) : (
                <>{Company[0].complainEmail}</>
              )}
              </Text>
            </View>

            <Image src={IataImage} style={styles.IataLogo} />
          </View>
        </View>

        <Text style={styles.text}>
          Thank you for booking with us. Check written details of your booking
          and the price we have agreed upon
        </Text>

        <View style={{ marginTop: 10, marginLeft: 5 }}>
          <Text style={styles.text}>Itinerary for:</Text>
        </View>

        <View style={{ marginTop: 15, marginLeft: 50 }}>
          {users.map((user, index) => (
            <Text style={styles.text}>
              {(
                user.title +
                " " +
                user.firstName +
                " " +
                user.middleName +
                " " +
                user.lastName
              ).toUpperCase()}
            </Text>
          ))}
        </View>

        <View style={styles.banner}>
          <Text style={{ ...styles.text, color: "white", textAlign: "center" }}>
            Due to airline and immigration regulations, it is imperative that
            the title(s)/first and middle name(s)/family name(s) shown above
            match exactly the details shown in your passport. Middle names are
            required when traveling to certain countries. Hyphens, apostrophes,
            spaces, and lowercase letters will not appear in airline
            reservations. Please contact us immediately if this is not the case.
            Any change to these names may incur amendment or cancellation fees.
          </Text>
        </View>

        <View style={styles.heading}>
          <Text style={styles.text}>Itinerary</Text>
        </View>

        <View>
          {sortedCombinedList.map((user, index) => {
            return (
              <View>
                {user.type === "Travel" && (
                  <View style={styles.flightSegment}>
                    <Text style={styles.text}>
                      {new Date(user.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </Text>

                    <View style={styles.flightDetails}>
                      <Text style={styles.text}>
                        <Text style={{ fontSize: 22, fontWeight: "bold" }}>
                          {getAirlineName(user.flightNumber)}
                        </Text>{" "}
                        - {user.flightNumber}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Departure City :{" "}
                        {airportList.find(
                          (airport) => airport.code === user.from
                        )?.name || "Unknown Airport"}{" "}
                        AT {user.departure}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Arrival City :{" "}
                        {airportList.find((airport) => airport.code === user.to)
                          ?.name || "Unknown Airport"}{" "}
                        AT {user.arrival}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Baggage Allowance : {user.baggage}
                      </Text>
                    </View>
                  </View>
                )}
                {user.type === "Hotel" && (
                  <View style={styles.flightSegment}>
                    <Text style={styles.text}>
                      {new Date(user.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </Text>

                    <View style={styles.flightDetails}>
                      <Text style={styles.text}>{user.name}</Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Check In :{" "}
                        {new Date(user.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Check Out :{" "}
                        {new Date(user.checkOutDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Room Type : {user.numberOfRooms} {user.roomType} with{" "}
                        {user.boardType}
                      </Text>
                    </View>
                  </View>
                )}

                {user.type === "Transport" && (
                  <View style={styles.flightSegment}>
                    <Text style={styles.text}>
                      {new Date(user.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </Text>

                    <View style={styles.flightDetails}>
                      <Text style={styles.text}>Transport</Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Car Type: {user.carType}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Pick up Location : {user.pickupLocation}
                      </Text>
                      <Text style={[styles.text, { marginBottom: 2 }]}>
                        Drop off Location : {user.dropoffLocation}
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            );
          })}
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Terms and Conditions
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              1. Please remember that the person making this booking accepts all
              the terms and conditions as stated below.
            </Text>
            <Text style={styles.text}>
              2. Tickets are neither changeable nor refundable (conditions
              apply).
            </Text>
            <Text style={styles.text}>
              3. Please note that all the packages are non-refundable and
              non-changeable once issued (conditions may apply).
            </Text>
            <Text style={styles.text}>
              4. Deposits only secure the seats, not the fares. Therefore, it is
              in your best interest to pay the balance amount at the time of
              booking.
            </Text>
            <Text style={styles.text}>
              5. Failure to sign this invoice within 48 hours will be considered
              as confirmed and accepted.
            </Text>
            <Text style={styles.text}>
              6. This document is not your E-Ticket; it is only an invoice
              confirming your package.
            </Text>
            <Text style={styles.text}>
              7. Prices are not guaranteed until the tickets are issued.
            </Text>
            <Text style={styles.text}>
              8. Room rates and airfares are subject to availability.
            </Text>
            <Text style={styles.text}>
              9. To secure your full package, 70% of your total committed price
              is required within 72 hours of booking.
            </Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Cancellation Policy
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              1. In case of cancellation of your Umrah package, holiday package,
              flight tickets, or any services booked through Cross Ocean Travel,
              the following conditions apply.
            </Text>
            <Text style={styles.text}>
              2. Cancellations may be adjusted for future reservations based on
              your initial deposit.
            </Text>
            <Text style={styles.text}>
              3. Hajj package cancellation charges are applicable as per the
              organizer’s terms and conditions, with a minimum charge of
              approximately  {bank === "American" ? (
                <Text>USD 350</Text>
              ) : (
                <>£250</>
              )} .
            </Text>
            <Text style={styles.text}>
              4. In extreme cases, a minimum charge of {bank === "American" ? (
                <Text>USD 200</Text>
              ) : (
                <>£100</>
              )} per person will be
              applied for Hajj cancellations.
            </Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Flight Requirements
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              1. Provide your name exactly as it appears on your passport.
            </Text>
            <Text style={styles.text}>
              2. Ensure there are no mistakes in your first name or surname.
              Passports should be valid for at least 6 to 8 months before
              travel.
            </Text>
            <Text style={styles.text}>
              3. Hajj package cancellation charges are applicable as per the
              organizer’s terms and conditions, with a minimum charge of
              approximately {bank === "American" ? (
                <Text>USD 350</Text>
              ) : (
                <>£250</>
              )}.
            </Text>
            <Text style={styles.text}>
              4. Special requests for meals or wheelchair assistance can be
              added as remarks in your booking through your agent.
            </Text>
            <Text style={styles.text}>
              5. You must double-check your E-Ticket number on the airline’s
              website immediately after receiving it from your travel agent.
            </Text>
            <Text style={styles.text}>
              6. Group fares or block seats are strictly non-refundable and
              non-changeable once issued.
            </Text>
            <Text style={styles.text}>
              7. You must provide a valid passport copy, email, and contact
              number to be included in your airline ticket before issuance.
            </Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            For Complaints
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              Please send us an email at 
               {bank === "American" ? (
                <Text> complaint@crossoceantravel.com </Text>
              ) : (
                <> {Company[0].complainEmail} </>
              )}
              in case of
              any complaint.
            </Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Office Address
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              

               {bank === "American" ? (
                <Text> 104 Province Dr, Apt D, Richmond, VA,<br/>23229, US</Text>
              ) : (
                <>{Company[0].address + " " + Company[0].address2}</>
              )}
            </Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Mode of Payments
          </Text>
          <View style={{ marginLeft: 100 }}>
            <Text style={styles.text}>
              1. Initial deposit over the phone using your Visa debit or credit
              card.
            </Text>
            {/* <Text style={styles.text}>
              2. Bank transaction to {Company[0].bankTitle} - Account #:{" "}
              {Company[0].AccountNo} - Sort Code: {Company[0].SortCode}
            </Text> */}
            <Text style={styles.text}>
              2 Bank transaction to
              {bank === "Allied" ? (
                <Text> Cross Ocean Travel (SMC Private)</Text>
              ) : (
                <Text> {Company[0].bankTitle}</Text>
              )}
              - Account #:{" "}
              {bank === "Tide" ? (
                <Text> 22037522 Sort Code : 04-06-05</Text>
              ) : (
                <></>
              )}
              {bank === "Natwest" ? (
                <Text> 30053951 Sort Code : 50-00-00</Text>
              ) : (
                <></>
              )}
              {bank === "Monzo" ? (
                <Text> 47905688 Sort Code : 04-00-03</Text>
              ) : (
                <></>
              )}
              {bank === "Allied" ? (
                <Text> IBAN - PK73ABPA0010118447480017</Text>
              ) : (
                <></>
              )}
              {bank === "Starlink" ? (
                <Text> 87891980 Sort Code : 60-83-71</Text>
              ) : (
                <></>
              )}
               {bank === "American" ? (
                <Text> 1470018733161 Routing Number : 051404260</Text>
              ) : (
                <></>
              )}
            </Text>

            <Text style={styles.text}>
              3. Secure 3D payment through the provided payment link.
            </Text>
            <Text style={styles.text}>4. Cash payment at the head office.</Text>
          </View>
        </View>

        <View style={styles.termConditions}>
          <Text
            style={[styles.text, { fontWeight: "extrabold", marginBottom: 20 }]}
          >
            Signature
          </Text>
          <View
            style={{
              marginLeft: 100,
              borderBottomWidth: 2,
              borderBottomColor: "black",
              width: "20%",
            }}
          />
        </View>
      </Page>
    </Document>
  );
};

// Main Component

function Hero() {
  const [reload, setReload] = useState(0);

  const location = useLocation();
  const {
    users,
    travels,
    hotels,
    transport,
    visa,
    ourReference,
    agentsName,
    totalQuote,
    totalPaid,
    bank,
  } = location.state;

  // settotalPaid(500)
  // Force re-render when the component updates

   const [salesPerson, setagents] = useRecoilState(agentState);
  



  const [agents, setAgents] = useRecoilState(agentState);
  useEffect(() => {
    const fetchAgents = async () => {
      const ref = collection(db, "Agents");
      const snap = await getDocs(ref);

      const list = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setAgents(list);
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setReload((prev) => prev + 1); // Increment state to force a re-render
    }, 2000000000); // Update every 2 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div>
      <h1>PDF Preview</h1>
      <PDFViewer width="100%" height="2000px" key={reload}>
        

        <MyDocument
          users={users}
          travels={travels}
          hotels={hotels}
          transport={transport}
          visa={visa}
          ourReference={ourReference}
          agentsName={agentsName}
          totalQuote={totalQuote}
          totalPaid={totalPaid}
          bank={bank}
          agents={salesPerson}
        />
      </PDFViewer>
    </div>
  );
}

export default Hero;
